import { useMantineTheme } from '@mantine-8/core';

const LightdashLogo = () => {
    const {
        colors: {
            foreground: [foregroundColor],
        },
    } = useMantineTheme();

    return (
        <svg
            width="130"
            viewBox="0 0 433 91"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_767_1973)">
                <g transform="translate(10,12)">
                    <defs>
                        <clipPath id="ballClip_767_1973">
                            <circle cx="32" cy="32" r="24" />
                        </clipPath>
                    </defs>

                    <circle
                        cx="32"
                        cy="32"
                        r="30"
                        stroke={foregroundColor}
                        strokeWidth={4}
                        fill="none"
                    />

                    <g clipPath="url(#ballClip_767_1973)" fill={foregroundColor}>
                        <rect x="18" y="40" width="5" height="16" rx="2" />
                        <rect x="26" y="37" width="5" height="19" rx="2" />
                        <rect x="34" y="34" width="5" height="22" rx="2" />
                        <rect x="42" y="31" width="5" height="25" rx="2" />
                        <rect x="50" y="28" width="5" height="28" rx="2" />
                    </g>
                </g>

                <text
                    x="86"
                    y="72"
                    fill={foregroundColor}
                    fontSize={54}
                    fontFamily="Arial, Helvetica, sans-serif"
                    fontWeight={700}
                    letterSpacing={0.2}
                    dominantBaseline="text-after-edge"
                >
                    Dashball
                </text>
            </g>

            <defs>
                <clipPath id="clip0_767_1973">
                    <rect width="433" height="91" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default LightdashLogo;
